module.exports = __webpack_public_path__ + "static/media/Spotify.44db0c36.svg";